import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { camelCaseKeys } from "utils/transform-object-keys";

import MuiWrapper from "./mount/mui-wrapper";
import NoNMuiWrapper from "./mount/non-mui-wrapper";
import QueryClientWrapper from "./mount/query-client-wrapper";
import validateSchema from "./validate-schema";

export default (Component, { withoutMui = false } = {}) =>
  document.addEventListener("DOMContentLoaded", () => {
    const container = document.getElementById("react");
    const root = createRoot(container);

    const props = camelCaseKeys(JSON.parse(container.dataset.props));

    const WrapperComponent = withoutMui ? NoNMuiWrapper : MuiWrapper;

    if (Component.schema) {
      validateSchema(Component.schema, props, Component.displayName);
    }

    root.render(
      <StrictMode>
        <WrapperComponent>
          <QueryClientWrapper>
            <Component {...props} />
          </QueryClientWrapper>
        </WrapperComponent>
      </StrictMode>,
    );
  });
